import {userConstants} from '../_constants';
import {userService} from '../_services';
import {history} from '../_helpers';
import authService from '../_services/cart/authService';
import alertService from '../_services/cart/alert.service';
import { productoActions } from './producto.actions';

export const userActions = {
    login,
    logout,
    registrar,
    getLogueado,
    traerUsuarios,
    traerMiPerfil
};


/**
 * @param redirect a donde ir despues del login automatico del alta. El alta de vendedores va a los
 *        planes; sin esto, el login decide (panel de vendedor o home).
 */
function registrar(values, setGrabando, redirect) {
    setGrabando(true);
    return dispatch => {
        userService.registrar(values)
            .then(
                data => {
                    // `login` es un thunk: sin dispatch devolvia una funcion que nadie ejecutaba, asi
                    // que el "ahora seras logueado automaticamente" del alta no pasaba nunca.
                    dispatch(login(values.email, values.password, undefined,
                        redirect ? () => history.push(redirect) : undefined));
                    setGrabando(false);
                },
                error => {
                    setGrabando(false);
                   alertService.error(error);
                }
            );
    };
}

/**
 * @param opciones `{numeroCelular, onError}`. `numeroCelular` solo lo manda el alta por Google.
 *        `onError` recibe el error y, si devuelve `true`, se da por atendido: es como el boton de
 *        Google se queda con el 428 ("falta el celular") sin que llegue a pantalla el cartel de
 *        "usuario/contrasena incorrecta", que en ese caso es mentira.
 */
function login(username, password, gResponse, onSuccess, opciones) {

    const {numeroCelular, onError} = opciones || {};

    return dispatch => {
        userService.login(username, password, gResponse, numeroCelular)
            .then(
                data => {                
                    authService.userLoginSucess();
                    authService.setExtraInfo(data.user);    
                    dispatch(success(data.user.token));                
                                      
                    dispatch(successUser(data.user))
                    productoActions.actualizoCartService();

                    if (!!onSuccess) {
                        onSuccess();
                    }else{
                        if (data.esVendedor) {
                            history.push('/vendedor/productos');
                        } else {
                            history.push('/home');
                        }
                    }
                    
                },
                error => {
                    dispatch(failure(error));

                    if (!!onError && onError(error) === true) {
                        return;
                    }

                    alertService.error("Usuario/Contraseña incorrecta, intente nuevamente");

                    if (error.status != undefined) {
                       alertService.error({
                           codigo: error.status,
                            message: error.statusText && error.statusText !== "" ? error.statusText : error.data.message ? error.data.message : 'No se ha podido autenticar'
                        });
                    }

                }
            );
    };

    function successUser(user) {
        return {type: userConstants.GETLOGUEADO_SUCCESS, user}
    }

    function success(user) {
        return {type: userConstants.LOGIN_SUCCESS, user}
    }

    function failure(error) {
        return {type: userConstants.LOGIN_FAILURE, error}
    }
}

function logout() {
    userService.logout();
    authService.userLogout();
    return {type: userConstants.LOGOUT};
}

function getLogueado() {
    return dispatch => {
        userService.getLogueado()
            .then(
                user => {
                    authService.userLoginSucess();
                    authService.setExtraInfo(user);
                   
                    dispatch(success(user))
                    productoActions.actualizoCartService();
                },
                error => {
                    authService.userLogout();
                    history.push('/');
                    alertService.error("Sesion Finalizada. Vuelva a iniciar sesión.");
                    productoActions.actualizoCartService();
                }
            );
    };

    function success(user) {
        return {type: userConstants.GETLOGUEADO_SUCCESS, user}
    }

    function failure(error) {
        return {type: userConstants.GETALL_FAILURE, error}
    }
}

function traerMiPerfil() {
    return dispatch => {
        userService.traerListadoGral()
            .then(
                users => {
                    dispatch(success(users));
                },
                error => {
                    alertService.error(error);
                }
            );
    };

    function success(users) {
        return {type: userConstants.GETALL_SUCCESS, users: users}
    }
}

function traerUsuarios() {
    return dispatch => {
        userService.traerListadoGral()
            .then(
                users => {
                    dispatch(success(users));
                },
                error => {
                    alertService.error(error);
                }
            );
    };

    function success(users) {
        return {type: userConstants.GETALL_SUCCESS, users: users}
    }
}
